import React, { useContext, useEffect } from 'react';
import { CookieUtil, Loader, PageContext } from '@axiom/ui';
import { connect } from 'react-redux';
import type { User } from '@axiom/validation';

import { SinglePageView } from '../components/SinglePageView/SinglePageView';
import { PreloadedUserStore } from '../stores/preloaded-user-store';

export const TalentDetailPage = connect(state => ({
  user: PreloadedUserStore.selectData(state),
}))(({ user }: { user?: User }) => {
  const shouldFetchUser = !user && CookieUtil.decodeUserCookie();

  const { setTitle } = useContext(PageContext);
  setTitle('AxiomLaw - Talent Detail');

  useEffect(() => {
    if (shouldFetchUser) {
      void PreloadedUserStore.load();
    }
  }, []);

  return shouldFetchUser ? (
    <Loader name="TALENT_DETAIL_PAGE_LOADER" />
  ) : (
    <SinglePageView />
  );
});
